import { MUIBreadcrumb } from "@abb/arcadia-ui-react"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"

export function BackToURL(props: { readonly url: string }) {
  const { url } = props
  const navigate = useNavigate()
  const handleClickBreadcrumb = useCallback(() => navigate(url), [navigate, url])

  return (
    <MUIBreadcrumb
      previousIconBackground="white"
      showPreviousNavigator
      onClickBreadcrumb={handleClickBreadcrumb}
    />
  )
}
